function show_my_videos(data) {
    html = '';
    if(data.items){
    data.items.forEach(function (item) {
        id = item.id.videoId;
        description = item.snippet.description;
        html += 'https://youtube.com/watch?v=' + id + '';
    });
    jQuery(".footer-top .weatherVideo").attr('href', html);
    theme.videoModal();
    }
}

jQuery.ajax({
    type: "GET",
    url: "https://www.googleapis.com/youtube/v3/search?key=AIzaSyAp8cDKo1XjC8Vg3yw4toChhz5OlQSKvig&channelId=UC6J_1lbR727yUrcm9m140Ug&part=snippet,id&order=date&maxResults=1",
    cache: false,
    dataType: 'jsonp',
    success: function (data) {
        show_my_videos(data);
    }
});

$(window).on('load', function() {
$('a[href*="/products/store-pickup-app"]').each(function() {
      	$('.cart__note').addClass("hide");
  		$('#CartSpecialInstructions').empty();
  $('#CartSpecialInstructions').val("");

});

});

$(document).ready(function(){
  $('.fake-add-to-cart').on('click',function(){
    id = $(this).data('id');
    $('#AddToCart-'+id).click();

    // Add class .btn--loading
    $(this).addClass('btn--loading');

  })
  // On the next ajaxComplete, remove any loading classes
  $(document).ajaxComplete(function(){
    $('.fake-add-to-cart.btn--loading').removeClass('btn--loading');
  });

  $('.pickup-button').click(function(){
  	$('.cart__note').addClass("hide");
  });

  $('#product-slider-fade').slick({
    infinite:true,
    autoplay: true,
   	autoplaySpeed: 4000,
    speed: 500,
    fade: true,
    cssEase: 'linear'
  });
   $('#product-slider-slide').slick({
    infinite:true,
    autoplay: true,
   	autoplaySpeed: 4000,
  });
  $('#article-slider-slide').slick({
    rows:2,
    infinite: true,
    slidesToShow:2,
    autoplay: true,
   	autoplaySpeed: 4000,
        arrows : false,
    responsive:[
      {
        breakpoint:1300,
        settings:{
          slidesToShow:3,
          dots:true
        }
      },
        {
        breakpoint:1050,
        settings:{
          slidesToShow:2,
                    dots:true

        }
      },
      {
        breakpoint:780,
        settings:{
          slidesToShow:1,
                    dots:true

        }
      },
    ]

  });
});
/*-- before and after --*/
function loadMore( wrapper ) {
    var toShow = $('.' + wrapper ).attr('data-showatstart');
    var newLimit = $('.' + wrapper ).attr('data-showatstart') * 1 + $('.' + wrapper ).attr('data-showperclick') * 1;
    for ( x = toShow; x < newLimit; x++ ) {
        $( '.' + wrapper + ' div:eq(' + x + ')').removeClass('hide');
    }

    if( $( '.' + wrapper + ' div').length <= newLimit ) {
        $( '.' + wrapper ).siblings( '.custom-learn-more').addClass("hide");
    }
    console.log( $( '.' + wrapper + ' div').length <= newLimit  );
    console.log( $( '.' + wrapper + ' div').length  );
    $('.' + wrapper ).attr('data-showatstart', newLimit);
}

/*-- testimonials --*/
function testimonialsLoadMore( toShow = 2 ) {
    var newLimit = $('#shopify-product-reviews' ).attr('data-tshowing') * 1 + (toShow * 1);

    $('.testimonialStyle').html('<style> #shopify-product-reviews .spr-review:nth-child(1n+' + newLimit + ') {  display: none; } </style>');

    if( $( '.spr-reviews > .spr-review').length < newLimit ) {
        $( '#shopify-product-reviews' ).siblings( '.custom-learn-more').addClass("hide");
    }

    $( '#shopify-product-reviews' ).attr('data-tshowing', newLimit);
}



/* 26-09-2019 */
$( "a" ).has( "img" ).css( "border-bottom", "none" );

/* CHANGE QUESTION MARK FONT */

$(".rte").children().each(function () {

$(this).html( $(this).html().replace(/(\?)(?![^<]*">)(?![^{]*})(?![^script]*script)(?![^style]*style)/g,'<span class="font-2">?</span>'));

});

/* Cart Drawer */
(function(){

  injectInCartDrawer = true;

  // Prevent the Checkout button from being redirected to the cart
  setTimeout(function() { storePickup.redirectButtonToCart = function() {};}, 0);

  const _injectDrawer = window._injectDrawer = () => {

    // Only run this if there's a checkout button on the page
    if (typeof jqCR === 'undefined' || !jqCR('[name=checkout]').get(0)) return;

    // If the URL has a hash, open the drawer
    if (window.location.hash === '#cart') {
      $('.js-drawer-open-cart').first().trigger('click');

      // Remove the hash
      history.pushState("", document.title, window.location.pathname + window.location.search);
    }

    // Inject the pickup button in the drawer
    const event = new CustomEvent('cart:refresh');
    document.dispatchEvent(event);

    // Automatically re-layout the cart drawer. Inject happens at 900
    setTimeout(function() {

      $('body').trigger('drawerOpen.CartDrawer');

      // Fix built-in drawer validation :/
      jqCR('form.cart').validate().destroy();

    }, 901);
  };

  $('body').on('added.ajaxProduct', _injectDrawer);
  $('body').on('updateCart.ajaxcart', () => {setTimeout(_injectDrawer, 100)});

  // Hack to fix Home Address validation
  $('body').on('click tap', '.cr-delivery-method', function() {
    setTimeout(function(){
      if ( jqCR('.js-toggle-pickup').hasClass('selected') ) {
          // Enable validate
          jqCR(jqCR('form.cart')).validate({
            submitHandler: storePickup.validateSubmiHandler.bind(storePickup)
          });
      } else {
        // Disable validate
        jqCR('form.cart').validate().destroy();
      }
    }, 0);
  });

  // If the URL is /cart, redirect to /#cart - the cart page doesn't work well with the drawer and pickup
  if (window.location.pathname === '/cart') {
    document.body.style.opacity = 0;
    window.location.href = '/#cart';
  }

  function removePickup() {
    $('.cr-shipping-method').trigger('click');

    if (document.querySelector(".pickup-wrapper")) {
        document.querySelector(".pickup-wrapper").remove();
    }

    jqCR.getJSON("/cart", function (response) {
        var items = response.items,
            attributes = response.attributes;

        attributes.Pickup_Information = "";
        attributes.Pickup_StoreID = "";
        attributes._unixTimestamp = "";
        attributes._formattedDate = "";
        attributes.Pickup_date = "";
        attributes.Pickup_time = "";
        attributes.Pickup_name = "";
        attributes.Pickup_phone = "";
        attributes.Pickup_extra1 = "";
        attributes.Pickup_extra2 = "";
        attributes.Pickup_extra3 = "";
        attributes.Pickup_Store = "";
        attributes.pickup = "";

        jqCR.ajax({
          type: "POST",
          url: "/cart/update.js",
          data: {
              attributes: attributes
          },
          dataType: "json",
          success: function () {
              console.log("Updated cart");
              $('body').trigger('drawerOpen.CartDrawer');
          },
          error: function (e, t) {
              console.log(e, t);
          }
        });

        for (var item in items) {
            if (parseInt(items[item].id) === pickupProduct) {
                jqCR.post("/cart/change.js", {
                    quantity: 0,
                    id: pickupProduct
                }, _ => {}, "json").always(function () {
                  console.log("refresh");
                  $('body').trigger('added.ajaxProduct');
              });
            }
        }

        // Redraw
        $('body').trigger('drawerOpen.CartDrawer');
    });
  }

  const excludedIds = [46021446172829, 46021446205597, 46021446238365];
  $('body').on('added.ajaxProduct', _checkExclusions);
  $('body').on('updateCart.ajaxcart', () => {setTimeout(_checkExclusions, 101)});

  function _checkExclusions() {
      const cartVariants = [];
      $('.ajaxcart__quantity input.js-qty__num').each(function(){
          const id = $(this).data('id');
          const variant = id.split(':')[0]
          cartVariants.push(parseInt(variant));
      })

      // Check if there's an intersection between the cart variants and the excluded ones
      const intersection = excludedIds.filter(value => cartVariants.includes(value));
      if (intersection.length) {
          console.log('Excluded product found, removing pickup...', intersection);
          setTimeout(removePickup, 901);
      }
  }

  document.addEventListener("crJQActivated", function (e) {
      console.log('Cart activated.. checking exclusions...');
      _checkExclusions();
  });

  _checkExclusions();
  window._checkExclusions = _checkExclusions;

})();
/* End Cart Drawer */
